import React from 'react';

const Italic = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    fill="currentColor"
    {...props}
  >
    <path d="M17.6122 7.99976L12.2788 23.9998H7.99939C7.44711 23.9998 6.99939 24.4475 6.99939 24.9998C6.99939 25.552 7.44711 25.9998 7.99939 25.9998H17.9994C18.5517 25.9998 18.9994 25.552 18.9994 24.9998C18.9994 24.4475 18.5517 23.9998 17.9994 23.9998H14.387L19.7204 7.99976H23.9994C24.5517 7.99976 24.9994 7.55204 24.9994 6.99976C24.9994 6.44747 24.5517 5.99976 23.9994 5.99976H19.0306C19.0098 5.9991 18.9891 5.99911 18.9684 5.99976H13.9994C13.4471 5.99976 12.9994 6.44747 12.9994 6.99976C12.9994 7.55204 13.4471 7.99976 13.9994 7.99976H17.6122Z" />
  </svg>
);

export default Italic;
